<template>
    <!-- /**
 * サイドバー
 */ -->
    <div class="side-menu">
        <ul class="nav flex-column side-menu-contents">
            <li class="nav-item my-2">
                <router-link class="nav-link menu-content" to="/"
                    >基礎編 TOP</router-link
                >
            </li>
            <li class="nav-item my-2">
                <details open>
                    <summary class="menu-content">学習項目一覧</summary>
                    <div>
                        <router-link class="nav-link" to="/menu/pswd"
                            >パスワード設定</router-link
                        >
                        <router-link class="nav-link" to="/menu/mail"
                            >メール利用</router-link
                        >
                        <router-link class="nav-link" to="/menu/web"
                            >ウェブ利用</router-link
                        >
                        <router-link class="nav-link" to="/menu/information"
                            >情報漏洩</router-link
                        >
                        <router-link class="nav-link" to="/menu/incident"
                            >インシデント対応</router-link
                        >
                    </div>
                </details>
            </li>
        </ul>
    </div>
</template>


<style lang="scss">
.side-menu {
    background-color: #ffe0c1;
    min-width: 250px;
    position: relative;
}

.side-menu a {
    color: black;
}

.side-menu-contents {
    position: absolute;
    top: 60px;
    left: 30px;
}

.menu-content {
    font-weight: bold;
}

summary {
    margin-left: 15px;
    margin-bottom: 8px;
}
</style>